import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';
import type { Firm } from '@/_types/models/firm';

export const firmSelfSignUp = async ({
  email,
  firmGroupId,
  fname,
  lname,
  phone,
  templateHashId,
  year,
  token,
}: APIRequest<{
  email: string;
  firmGroupId?: string;
  fname: string;
  lname: string;
  phone?: string;
  templateHashId?: string;
  year: string;
}>): APIResponsePromise<{ auth_token: string }> =>
  await _callBackend(
    '/resources/firm_self_sign_up',
    'POST',
    {
      email,
      firm_group_id: firmGroupId,
      fname,
      lname,
      phone_number: phone,
      template_hash_id: templateHashId,
      year,
    },
    token,
  );

export const firmSelfSignUpCreateQuestionnaire = async ({
  templateHashId,
  year,
  token,
}: APIRequest<{
  templateHashId: string;
  year: string;
}>): APIResponsePromise<{ questionnaire_id: string }> => {
  return await _callBackend(
    '/resources/firm_self_sign_up_create_questionnaire',
    'POST',
    { template_hash_id: templateHashId, year },
    token,
  );
};

export const getTemplate = async ({
  hashId,
}: APIRequest<{
  hashId: string;
}>): APIResponsePromise =>
  await _callBackend(`/resources/get_template?hash_id=${hashId}`, 'GET', null);

export const getFirm = async ({
  hashId,
}: APIRequest<{
  hashId: string;
}>): APIResponsePromise<Firm> =>
  await _callBackend(`/resources/get_firm?hash_id=${hashId}`, 'GET', null);

export const getQuestionnaireIdByTemplate = async ({
  hashId,
  taxYear,
  username,
  token,
}: APIRequest<{
  hashId: string;
  taxYear: string;
  username: string;
}>): APIResponsePromise<{ questionnaire_id: string }> =>
  await _callBackend(
    `/resources/get_questionnaire_id_by_template?hash_id=${hashId}&tax_year=${taxYear}&username=${encodeURIComponent(username)}`,
    'GET',
    null,
    token,
  );
